import { NgModule } from '@angular/core';
import { BreadcrumbsComponent } from './breadcrumbs.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationActionsComponent } from './navigation-actions.component';
import { PageHeaderComponent } from './page-header.component';
import { NavigationService } from './navigation.service';
import { LoadingIndicatorComponent } from './loading-indicator.component';

@NgModule({
  imports: [CommonModule, MatIconModule, RouterModule, MatButtonModule, MatToolbarModule],
  exports: [PageHeaderComponent, BreadcrumbsComponent, NavigationActionsComponent, LoadingIndicatorComponent],
  declarations: [BreadcrumbsComponent, NavigationActionsComponent, PageHeaderComponent, LoadingIndicatorComponent],
  providers: [NavigationService],
})
export class NavigationModule {}
